<ng-template #datefield let-section let-field="field" let-textField="textField" let-label="label" let-visible="visible" let-width="width">
  <li *ngIf="(print && docConfig.get(field).checked !== false) || (!print && (this.data.visibleMap[field] || this.data.readOnlyMap[field]))"
    class="report-date"
    [ngStyle]="(print ? { width: '125px', 'text-align': 'center' } : { width: width })"
  >
      <label *ngIf="label">
        <ng-container *ngIf="section && isCheckBox(section) && !print">
          <input type="checkbox" [ngModel]="section.checked" (change)="toggleItem(section)" [attr.disabled]="disabled ? true : null" />&nbsp;
        </ng-container>
        {{label}}
        <!-- FF{{compilation.erpDate[field] | json}}JJ -->
        <button *ngIf="!print && compilation.erpDate?.[field]?.history?.length" class="history-btn" [nbPopover]="dateHistory" nbPopoverTrigger="hover">H</button>
      </label>
      <label *ngIf="!label && section && section['label']">
        <ng-container *ngIf="isCheckBox(section) && !print">
          <input type="checkbox" [ngModel]="section.checked" (change)="toggleItem(section)" [attr.disabled]="disabled ? true : null" />&nbsp;
        </ng-container>
        {{section['label']}}
        <button *ngIf="!print && compilation.erpDate?.[field]?.history?.length" class="history-btn" [nbPopover]="dateHistory" nbPopoverTrigger="hover">H</button>
        <!-- FF{{compilation.erpDate[field] | json}}JJ -->
        <ng-container *ngIf="field === 'expectedNextInvoiceDate'">
          <!-- <span *ngIf="!print && field === 'expectedNextInvoiceDate' && !disabled" class="pseudo-link border rounded px-2 ml-3" 
            [title]="compilation.nextInvoiceDateAttached ? 'detach from dispatch date' : 'attach to dispatch date'"
            (click)="toggleNextInvoiceDateToDispatchDateAttached()">
            {{ compilation.nextInvoiceDateAttached ? 'detach' : 'attach' }}
          </span> -->
          <button *ngIf="!disabled" class="nrk-button" [nbPopover]="nextInvoiceDateSelection">assign Date</button>
          <ng-template #nextInvoiceDateSelection>
            <div class="p-4">
              <h5 class="mb-3 text-center">Expected Next Invoice Date</h5>
              <div class="mb-3">
                <ngx-doc-form-dropdown [(value)]="compilation.nextInvoiceDateRef" [options]="paymentDateOptions" (valueChange)="compilation.expectedNextInvoiceDate = compilation[compilation.nextInvoiceDateRef]"></ngx-doc-form-dropdown>
              </div>
              <ng-container *ngIf="!compilation.nextInvoiceDateRef">
                <ngx-doc-form-date class="fullwidth" [(value)]="$any(compilation).expectedNextInvoiceDate"></ngx-doc-form-date>
              </ng-container>
              <!-- <div>{{(item.paymentDateRef ? compilation[item.paymentDateRef] : item.paymentDate) | date : 'yyyy-MM-dd' }}</div> -->
            </div>
          </ng-template>
          <ngx-doc-form-date *ngIf="compilation.nextInvoiceDateRef" class="fullwidth" [(value)]="compilation[compilation.nextInvoiceDateRef]" [disabled]="true"></ngx-doc-form-date>
          <ngx-doc-form-date *ngIf="!compilation.nextInvoiceDateRef" class="fullwidth" [(value)]="$any(compilation).expectedNextInvoiceDate" [disabled]="disabled"></ngx-doc-form-date>
        </ng-container>
      </label>

    <ngx-doc-form-date *ngIf="!print && !textField && field !== 'expectedNextInvoiceDate'" class="fullwidth" 
      [(value)]="compilation[field]"
      [disabled]="checkDisabled(field)"
      [erpDate]="compilation.erpDate?.[field]"
      (valueChange)="reportDateFieldChanged(field)">
    </ngx-doc-form-date>
    <!-- TODO: remove textField (no longer date/text toggle fields needed)-->
    <!-- <ngx-doc-form-date *ngIf="!print && textField" class="fullwidth" 
      [textToggle]="true"
      [(text)]="compilation[textField]"
      [(value)]="compilation[field]"
      [disabled]="checkDisabled(field)"
      (valueChange)="reportDateFieldChanged(field)">
    </ngx-doc-form-date> -->
    <div *ngIf="print && field !== 'expectedNextInvoiceDate'">{{(compilation[field] && compilation[field] | date : 'yyyy-MM-dd') || '-' }}</div>
  </li>

  <ng-template #dateHistory>
    <div class="m-3" *ngIf="compilation.erpDate?.[field]?.history?.length">
      <b>Date History</b>
      <table class="nrk-table">
        <tr><th>Date</th><th>User</th><th>Remark</th><th>Updated At</th></tr>
        <tr *ngFor="let date of compilation.erpDate[field].history">
          <td><b>{{date.val | date : "yy-MM-dd"}}</b></td>
          <td>{{date.user}}</td>
          <td>{{date.remark}}</td>
          <td style="font-size:smaller;color:gray;">{{date.updatedAt | date : "yy-MM-dd HH:mm"}}</td>
        </tr>
      </table>
    </div>
    <!-- <div class="m-3" *ngIf="!compilation.erpDate?.[field]?.history?.length">
      No date history present.
    </div> -->
  </ng-template>

</ng-template>


<ng-template #textfield let-section let-field="field" let-label="label">
  <li *ngIf="this.data.visibleMap[field] || this.data.readOnlyMap[field]" class="report-number">
    <label *ngIf="label">{{label}}</label>
    <label *ngIf="!label && section && section['label']">{{section['label']}}</label>
    <ngx-doc-form-texfield *ngIf="!print" class="fullwidth" 
      [(value)]="compilation[field]" 
      [disabled]="checkDisabled(field)" 
      (valueChange)="reportDateFieldChanged(field)">
    </ngx-doc-form-texfield>
    <div *ngIf="print">{{compilation[field] || '-'}}</div>
  </li>  
</ng-template>

<!-- ================================================== direct shipment ===================================================================== -->

<!-- <ng-container *ngIf="print && tree?.linkedPfspos?.length && tree.linkedPfspos[0].directDelivery">
  <div *ngIf="['OC', 'DN', 'PL', 'IN', 'SPO', 'PFSPO', 'CS'].includes(typeData.get(compilation.type).code)" class="nrk-border-box mb-3">
    Direct shipment from factory to final customer
  </div>
</ng-container>
<ng-container *ngIf="print && !tree?.linkedPfspos?.length && tree.linkedPfspos[0].directDelivery">
  <div *ngIf="isNRVIDelivery() && ['OC', 'DN', 'PL', 'IN', 'SPO', 'PFSPO', 'CS'].includes(typeData.get(compilation.type).code)" class="nrk-border-box mb-3">
    Final shipment from NRVI warehouse to final customer
  </div>
  <div *ngIf="!isNRVIDelivery() && ['OC', 'DN', 'PL', 'IN'].includes(typeData.get(compilation.type).code)" class="nrk-border-box mb-3">
    Final sh ipment from NRK warehouse to final customer
  </div>
  <div *ngIf="!isNRVIDelivery() && ['SPO', 'PFSPO', 'CS'].includes(typeData.get(compilation.type).code)" class="nrk-border-box mb-3">
    Shipment to NRKA warehouse
  </div>
</ng-container> -->

<!-- =================================================== display dates ====================================================================== -->

<ng-container *ngIf="compilation.type > 2 || !print || compilation.dateText">
  <!-- <div *ngIf="print && (showDisplayDates() || compilation.dateText)"><b>{{ compilation.invoiceType === 'service' ? 'Service Time' : 'Display Dates' }}</b></div> -->
  <div *ngIf="!print">{{ compilation.invoiceType === 'service' ? 'Service Time' : 'Display Dates from OC' }}</div>

  <ul *ngIf="!print || showDisplayDates()" class="report-fields nrk-border-box mb-2">

    <!-- Date of Engineering Drawings -->
    <ng-container *ngIf="data.visibleMap.dateOfDrawings && (compilation?.invoiceType != 'service') && (!print || compilation.dateOfDrawings)">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfDrawings'), field: 'dateOfDrawings', label: 'Engineering Drawings'}"></ng-container>
      </div>
    </ng-container>

    <!-- Date of Part Sourcing -->
    <ng-container *ngIf="data.visibleMap.dateOfSourcing && (compilation?.invoiceType != 'service') && (!print || compilation.dateOfSourcing)">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfSourcing'), field: 'dateOfSourcing', label: 'Part Sourcing'}"></ng-container>
      </div>
    </ng-container>

    <!-- Date of FAT -->
    <ng-container *ngIf="data.visibleMap.dateOfFAT && (compilation?.invoiceType != 'service') && (!print || compilation.dateOfFAT)">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfFAT'), field: 'dateOfFAT', label: 'Date of FAT'}"></ng-container>
      </div>
    </ng-container>

    <!-- Date of Service -->
    <ng-container *ngIf="data.visibleMap.dateOfService && (!print || compilation.dateOfService || compilation.legacyDateOfService) && compilation.invoiceType === 'service'">
      <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfService'), field: 'dateOfService', textField: 'legacyDateOfService', label: 'Date of Service' }"></ng-container> -->
      <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfService'), field: 'dateOfService', label: 'Date of Service' }"></ng-container>
    </ng-container>

    <!-- Date of Pickup -->
    <ng-container *ngIf="data.visibleMap.dateOfPickup && (compilation?.invoiceType != 'service') && (!print || compilation.dateOfPickup)">
      <div [ngClass]="compilation.dateOfPickup && compilation.dateOfPickup !== compilation.readyForPickupDate ? 'd-inline-block date-mismatch' : 'd-inline-block'">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfPickup'), field: 'dateOfPickup', label: 'Ready for Pick-up' }"></ng-container>
      </div>
    </ng-container>

    <!-- Date of EXW -->
    <ng-container *ngIf="data.visibleMap.exwDate && (compilation?.invoiceType != 'service') && (!print || compilation.legacyExwDate || compilation.exwDate)">
      <div [ngClass]="compilation.exwDate && compilation.exwDate !== compilation.exwJapanDate ? 'd-inline-block date-mismatch' : 'd-inline-block'">
        <!-- <ng-container [ngStyle]="compilation.exwDate !== compilation.exwJapanDate && { 'border': '5px solid red' }"
          *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('exwDate'), field: 'exwDate', textField: 'legacyExwDate', label: 'EXW Factory' }">
        </ng-container> -->
        <ng-container [ngStyle]="compilation.exwDate !== compilation.exwJapanDate && { 'border': '5px solid red' }"
          *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('exwDate'), field: 'exwDate', label: 'EXW Factory' }">
        </ng-container>
      </div>
    </ng-container>

    <!-- Date of ETA AT -->
    <ng-container *ngIf="data.visibleMap.dateOfVieArrival && (compilation?.invoiceType != 'service') && (!print || compilation.legacyDateOfVieArrival || compilation.dateOfVieArrival) && !compilation.directDelivery">
      <div [ngClass]="compilation.dateOfVieArrival && compilation.dateOfVieArrival !== compilation.arrivingVieDate ? 'd-inline-block date-mismatch' : 'd-inline-block'">
        <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfVieArrival'), field: 'dateOfVieArrival', textField: 'legacyDateOfVieArrival', label: 'Arriving Vienna' }"></ng-container> -->
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfVieArrival'), field: 'dateOfVieArrival', label: 'ETA AT' }"></ng-container>
      </div>
    </ng-container>

    <!-- Date of Dispatch -->
    <ng-container *ngIf="data.visibleMap.dateOfDispatch && (compilation?.invoiceType != 'service') && (!print || compilation.legacyDateOfDispatch || compilation.dateOfDispatch) && !compilation.directDelivery">
      <div [ngClass]="compilation.dateOfDispatch && compilation.dateOfDispatch !== compilation.vieDispatchDate ? 'd-inline-block date-mismatch' : 'd-inline-block'">
        <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfDispatch'), field: 'dateOfDispatch', textField: 'legacyDateOfDispatch', label: 'Dispatch date' }"></ng-container> -->
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfDispatch'), field: 'dateOfDispatch', label: 'Dispatch Date' }"></ng-container>
      </div>
    </ng-container>

    <!-- ETA customer date -->
    <ng-container *ngIf="data.visibleMap.dateOfDelivery && (compilation?.invoiceType != 'service') && (!print || compilation.legacyDateOfDelivery || compilation.dateOfDelivery)">
      <div [ngClass]="compilation.dateOfDelivery && compilation.dateOfDelivery !== compilation.etaCustomerDate ? 'd-inline-block date-mismatch' : 'd-inline-block'">
        <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfDelivery'), field: 'dateOfDelivery', textField: 'legacyDateOfDelivery', label: 'ETA customer' }"></ng-container> -->
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfDelivery'), field: 'dateOfDelivery', label: 'ETA Customer' }"></ng-container>
      </div>
    </ng-container>

    <!-- Date of SAT -->
    <ng-container *ngIf="data.visibleMap.dateOfSAT && (compilation?.invoiceType != 'service') && (!print || compilation.dateOfSAT)">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('dateOfSAT'), field: 'dateOfSAT', label: 'Date of SAT'}"></ng-container>
      </div>
    </ng-container>

    <!-- Warranty Months-->
    <ng-container *ngIf="data.visibleMap.warrantyMonths && (compilation?.invoiceType != 'service') && !print">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="textfield; context: { $implicit: docConfig.get('warrantyMonths'), field: 'warrantyMonths', label: 'Warranty Months'}"></ng-container>
      </div>
    </ng-container>

    <!-- End of Warranty -->
    <ng-container *ngIf="data.visibleMap.endOfWarranty && (compilation?.invoiceType != 'service') && (!print || compilation.endOfWarranty)">
      <div class="d-inline-block">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('endOfWarranty'), field: 'endOfWarranty', label: 'End of Warranty'}"></ng-container>
      </div>
    </ng-container>

    <!-- <div *ngIf="!(locked || tree.linkedCS)" style="display:flex;flex-direction:row;margin-top:3px;width:100%;">
      <ngx-doc-form-texfield style="width:100%;" class="fullwidth" [(value)]="selected.meansOfTransport"></ngx-doc-form-texfield>
      &nbsp;<button class="nrk-doc-button" (click)="addMeansOfTransport()" title="Add transportation to list">+</button>
      &nbsp;<button class="nrk-doc-button" (click)="removeMeansOfTransport()" title="Remove transportation from list">-</button>
    </div> -->

    <!-- <li *ngIf="!print" style="margin:0 1em">
      <div style="margin-right: 2em;">
        <div class="mb-1" *ngIf="data.visibleMap.displayDatesStore && !disabled">
          <ngx-doc-form-filter-select class="fullwidth" [(value)]="compilation.dateText" placeholder="Select date text"
            [options]="dateTextOptions" (valueChange)="dateTextOptionsChanged($event)" [disabled]="disabled">
          </ngx-doc-form-filter-select>
        </div>
        <div class="mr-4"><ngx-form-text [multiline]="1" [(value)]="compilation.dateText" [disabled]="disabled"></ngx-form-text></div>
        <div style="float:right;position:relative;bottom:2.2em;left:2.3em" *ngIf="!disabled">
          <button *ngIf="data.visibleMap.displayDatesStore" class="nrk-doc-button" (click)="addDateText()" title="Add date text to list">+</button>
          <button *ngIf="data.visibleMap.displayDatesStore" class="nrk-doc-button ml-1" (click)="removeDateText()" title="Remove date text from list">-</button>
          <button *ngIf="!data.visibleMap.displayDatesStore" class="nrk-doc-button" (click)="compilation.dateText = ''">X</button>
        </div>
      </div>
    </li> -->

    <li *ngIf="!print" style="margin:0 1em">
      <div style="margin-right: 2em;">
        <div class="mb-1" *ngIf="!disabled">
          <ngx-doc-form-filter-select class="fullwidth" [(value)]="compilation.dateText" placeholder="Select Date Text"
            [options]="dateTextOptions" (valueChange)="dateTextOptionsChanged($event)" [disabled]="disabled">
          </ngx-doc-form-filter-select>
        </div>
        <div class="mr-4"><ngx-form-text [multiline]="1" [(value)]="compilation.dateText" [disabled]="disabled"></ngx-form-text></div>
        <div style="float:right;position:relative;bottom:2.2em;left:2.3em" *ngIf="!disabled">
          <button *ngIf="!disabled" class="nrk-doc-button" (click)="addDateText()" title="Add Date Text to List">+</button>
          <button *ngIf="!disabled" class="nrk-doc-button ml-1" (click)="removeDateText()" title="Remove Date Text from List">-</button>
          <!-- <button *ngIf="!data.visibleMap.displayDatesStore" class="nrk-doc-button" (click)="compilation.dateText = ''">X</button> -->
        </div>
      </div>
    </li>

  </ul>

  <ul *ngIf="print && compilation.dateText" class="report-fields nrk-border-box mb-2">
    <li style="margin:0 1em; width:100%">
      <div style="white-space: pre-wrap">{{compilation.dateText}}</div>
    </li>
  </ul>

</ng-container>

<!-- =================================================== transport run ======================================================================
<ng-container *ngIf="!print && (data.visibleMap.transportStatus || data.visibleMap.spoStatus)">
  <hr>
  <ul *ngIf="compilation.transportRun" class="transport-run list-group-horizontal">

  </ul>
  <hr>
</ng-container> -->

<!-- <ng-container *ngIf="print && ((data.visibleMap.spoStatus && compilation.transportRun?.spoStatus !== null) || (typeData.get(compilation.type).code === 'CS' && compilation.transportRun?.transportStatus > 0))">
  <b>Status</b>
  <ul class="transport-run list-group-horizontal  nrk-border-box">
    <li *ngIf="typeData.get(compilation.type).code === 'CS' && compilation.transportRun?.transportStatus > 0">
      <div><span class="section-header">Transport Status:</span>{{transportStatusData.get(compilation.transportRun?.transportStatus).name}}</div>
    </li>
    <li *ngIf="data.visibleMap.spoStatus && compilation.transportRun?.spoStatus !== null">
      <div><span class="section-header">SPO Status:</span>{{ compilation.transportRun?.spoStatus ? (compilation.transportRun.spoStatus === 2 ? 'Completed' : 'Confirmed') : 'Unconfirmed' }}</div>
    </li>
  </ul>
</ng-container> -->

<ng-container *ngIf="print && (typeData.get(compilation.type).code === 'CS' && compilation.transportRun?.transportStatus > 0)">
  <b>Status</b>
  <ul class="transport-run list-group-horizontal  nrk-border-box">
    <li *ngIf="typeData.get(compilation.type).code === 'CS' && compilation.transportRun?.transportStatus > 0">
      <div><span class="section-header">Transport Status:</span>{{transportStatusData.get(compilation.transportRun?.transportStatus).name}}</div>
    </li>
    <!-- <li *ngIf="data.visibleMap.spoStatus && compilation.transportRun?.spoStatus !== null">
      <div><span class="section-header">SPO Status:</span>{{ compilation.transportRun?.spoStatus ? (compilation.transportRun.spoStatus === 2 ? 'Completed' : 'Confirmed') : 'Unconfirmed' }}</div>
    </li> -->
  </ul>
</ng-container>

<!-- <ng-container *ngIf="print && typeData.get(compilation.type).code === 'CS' && compilation.transportRun?.transportStatus !== null">
  <b>Transport Status</b>
  <ul class="transport-run list-group-horizontal  nrk-border-box">
    <li *ngIf="data.visibleMap.spoStatus && compilation.transportRun?.spoStatus !== null">
      <div><span class="section-header">Transport status:</span>{{ transportStatusData.get(compilation.transportRun?.transportStatus).name }}</div>
    </li>
  </ul>
</ng-container> -->  

<!-- =================================================== report dates ====================================================================== -->
<ng-container *ngIf="!print && data.visibleMap.showReportDates">
  <br>
  Report Dates
  <div *ngIf="tree.isLoading"><ngx-loading-spinner [loading]="tree.isLoading"></ngx-loading-spinner></div>
  <div *ngIf="!tree.isLoading" class="report-dates-container">
    <div *ngIf="data.visibleMap.directDelivery">
      <input type="checkbox" name="dirdel" [(ngModel)]="compilation.directDelivery" (ngModelChange)="directDeliveryChanged($event)" [attr.disabled]="disabled ? true: null"/>
      <label for="dirdel">&nbsp;&nbsp;&nbsp;{{docConfig.get('directDelivery').label}}</label>
    </div>
    <div *ngIf="data.readOnlyMap.directDelivery">
      <input type="checkbox" name="dirdel" [ngModel]="tree?.linkedPfspos?.length && tree.linkedPfspos[0]?.directDelivery" disabled/>
      <label for="dirdel">&nbsp;&nbsp;&nbsp;{{docConfig.get('directDelivery').label}}</label>
    </div>
    <div *ngIf="data.visibleMap.pfspoWithShipment && compilation.pfspoWithShipment">
      <input type="checkbox" name="pfspows" [(ngModel)]="compilation.pfspoWithShipment" (ngModelChange)="pfspoWithShipmentChanged($event)" [attr.disabled]="true"/>
      <label for="pfspows">&nbsp;&nbsp;&nbsp;{{docConfig.get('pfspoWithShipment').label}}</label>
    </div>

    <ng-container *ngIf="data.visibleMap.exwJapanDate || data.readOnlyMap.exwJapanDate">
      &nbsp;&nbsp;&nbsp;CS / (PF)SPO Related
      <div class="report-date-section">
        <ul class="report-fields" *ngIf="compilation">
          <li *ngIf="data.visibleMap.csTable && !print && csTable && csTable.length" class="report-date" style="width:3rem"><button class="nrk-button ml-1" (click)="csDateToggle=!csDateToggle">▼</button></li>
          <li *ngIf="canUnlockCsSpoDates()" class="report-date" style="width:auto">
            <div>
              <ng-container *ngIf="!csSpoDatesUnlocked">
                <button class="nrk-button ml-1" (click)="unlockCsSpoDates()">{{getUnlockLabel()}}</button>
                <ngx-doc-form-dropdown *ngIf="!getLinkedCS() && getSelectableSpos().length > 1"
                  class="fullwidth" style="display:inline-block;width:16em" [value]="referenceSpoCode"
                  [options]="getSpoOptions()" (valueChange)="referenceSpoChanged($event)" [disabled]="false"></ngx-doc-form-dropdown>
              </ng-container>
              <ng-container *ngIf="csSpoDatesUnlocked">
                <button class="nrk-button ml-1" (click)="lockCsSpoDates()">lock</button>
                <div class="ml-2" style="font-size:smaller"><i>editable dates will be saved to<br>{{getCsSpoSaveTarget()?.nameOverride ?? getCsSpoSaveTarget()?.code}}</i></div>
              </ng-container>
            </div>
          </li>

          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('requestedExwDate'), field: 'requestedExwDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('internalExwDate'), field: 'internalExwDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('exwJapanDate'), field: 'exwJapanDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="textfield; context: { $implicit: docConfig.get('transferTime1'), field: 'transferTime1' }"></ng-container>
          <ng-container *ngIf="!(this.tree.linkedPfspos?.length && this.tree.linkedPfspos[0]?.directDelivery)">
            <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('arrivingVieDate'), field: 'arrivingVieDate' }"></ng-container>
          </ng-container>

          <li *ngIf="tree.linkedCSs && tree.linkedCSs[0]" class="d-inline-block">
            <div class="d-inline-block" style="max-width:23em">
              <label>carrier / method:</label><br>
              <div class="disabled-box">{{tree?.linkedCS?.meansOfTransport || compilation?.meansOfTransport}}</div>
            </div>
          </li>

          <li *ngIf="compilation.transportRun && data.visibleMap.transportStatus && !['IN', 'PFIN'].includes(typeData.get(this.compilation.type).code)" class="report-date">
            <div>
              <ul class="list-group-horizontal list-unstyled">
                <li>
                  <span class="section-header">Transport status:</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.transportStatus" name="transportStatus" 
                    [value]="1" [attr.disabled]="!checkSpoStatus(1) || tree.linkedCS ? true : null" />
                  <span [ngClass]="{'nrk-pointer': checkSpoStatus(1) && !tree.linkedCS }" (click)="checkSpoStatus(1) && !tree.linkedCS && compilation.transportRun.transportStatus = 1">&nbsp;&nbsp;&nbsp;Planned</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.transportStatus" name="transportStatus" 
                    [value]="2" [attr.disabled]="!checkSpoStatus(2) || tree.linkedCS ? true : null" />
                  <span [ngClass]="{'nrk-pointer': checkSpoStatus(2) && !tree.linkedCS}" (click)="checkSpoStatus(2) && !tree.linkedCS && compilation.transportRun.transportStatus = 2">&nbsp;&nbsp;&nbsp;En route</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.transportStatus" name="transportStatus" 
                    [value]="3" [attr.disabled]="!checkSpoStatus(3) || tree.linkedCS ? true : null" />
                  <span [ngClass]="{'nrk-pointer': checkSpoStatus(3) && !tree.linkedCS}" (click)="checkSpoStatus(3) && !tree.linkedCS && compilation.transportRun.transportStatus = 3">&nbsp;&nbsp;&nbsp;Completed</span>
                </li>
              </ul>
            </div>
          </li>

          <li *ngIf="csTable && csTable.length" class="report-date">Related Documents: {{csTable.length}}</li>
        </ul>

        <table *ngIf="data.visibleMap.csTable && csDateToggle && csTable && csTable.length" class="nrk-table w-100">
          <tr><th>Doc Pos</th><th>PFSPO#</th><th>SPO Pos</th><th>Q</th><th>Unit</th><th>Pick-up Date</th><th>EXW</th><th>VIE Arrival</th><th>PFSPO Status</th><th>Transport Status</th><th>Assigned Q</th></tr>
          <tr *ngFor="let spo of csTable">
            <td>{{spo.parentPos+1}}</td>
            <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
              [queryParams]="{code: spo.code}" >{{spo | documentNumber}}</a></td>
            <td>{{spo.pos}}</td>
            <td>{{spo.docLineItem?.displayUnitQuantity}}</td>
            <td>{{unitData.get(spo.docLineItem?.displayUnit)?.short}}</td>
            <td>{{spo.doc?.readyForPickupDate | date : 'yy-MM-dd'}}</td>
            <td>{{spo.doc?.exwJapanDate | date : 'yy-MM-dd'}}</td>
            <td>{{spo.doc?.arrivingVieDate | date : 'yy-MM-dd'}}</td>
            <td>{{spoStatusData.get(spo.doc?.transportRun?.spoStatus)?.name}}</td>
            <td>{{getTransportStatus(spo)}}</td>
            <td>{{spo.quantity}}</td>
          </tr>
        </table>
      </div>
    </ng-container>
    <ng-container *ngIf="data.visibleMap.readyForPickupDate || data.readOnlyMap.readyForPickupDate">
      &nbsp;&nbsp;&nbsp;(PF)SPO Related
      <div class="report-date-section">
        <ul class="report-fields" *ngIf="compilation">
          <li *ngIf="data.visibleMap.pfspoTable && !print && pfspoTable && pfspoTable.length" class="d-inline-block"><button class="nrk-button ml-1" (click)="pfspoDateToggle=!pfspoDateToggle">▼</button></li>

          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('readyForPickupDate'), field: 'readyForPickupDate' }"></ng-container>

          <li *ngIf="data.visibleMap.spoStatus" class="d-inline-block report-date">
            <div>
              <ul class="list-group-horizontal list-unstyled">
                <li>
                  <span class="section-header">SPO Status:</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.spoStatus" name="spoStatus" 
                    [value]="0" [attr.disabled]="disabled ? true : null" />
                  <span class="nrk-pointer" (click)="!disabled && compilation.transportRun.spoStatus = 0">&nbsp;&nbsp;&nbsp;Unconfirmed</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.spoStatus" name="spoStatus" 
                    [value]="1" [attr.disabled]="disabled ? true : null" />
                  <span class="nrk-pointer" (click)="!disabled && compilation.transportRun.spoStatus = 1">&nbsp;&nbsp;&nbsp;Confirmed</span>
                </li>
                <!-- <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.spoStatus" name="spoStatus" 
                    [value]="2" [attr.disabled]="disabled ? true : null" />
                  <span class="nrk-pointer" (click)="!disabled && compilation.transportRun.spoStatus = 2">&nbsp;&nbsp;&nbsp;Completed</span>
                </li> -->
              </ul>
            </div>
          </li>
          
          <li *ngIf="data.visibleMap.spoStatus" class="d-inline-block">
            <div>
              <ul class="list-group-horizontal list-unstyled">
                <li>
                  <span class="section-header">SPO Availability Status:</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.availabilityStatus" name="availabilityStatus" 
                    [value]="1" disabled />
                  <span>&nbsp;&nbsp;&nbsp;Not Completed</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.availabilityStatus" name="availabilityStatus" 
                    [value]="2" disabled />
                  <span>&nbsp;&nbsp;&nbsp;Completed</span>
                </li>
                <!-- <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.availabilityStatus" name="availabilityStatus" 
                    [value]="1" [attr.disabled]="disabled ? true : null" />
                  <span class="nrk-pointer" (click)="!disabled && compilation.transportRun.availabilityStatus = 1">&nbsp;&nbsp;&nbsp;Not completed</span>
                </li>
                <li>
                  <input type="radio" [(ngModel)]="compilation.transportRun.availabilityStatus" name="availabilityStatus" 
                    [value]="2" [attr.disabled]="disabled ? true : null" />
                  <span class="nrk-pointer" (click)="!disabled && compilation.transportRun.availabilityStatus = 2">&nbsp;&nbsp;&nbsp;Completed</span>
                </li> -->
              </ul>
            </div>
          </li>
          
          <li *ngIf="pfspoTable && pfspoTable.length" class="report-date">Related Documents: {{pfspoTable.length}}</li>
        </ul>

        <table *ngIf="data.visibleMap.pfspoTable && pfspoDateToggle && pfspoTable && pfspoTable.length" class="nrk-table w-100">
          <tr><!--<th>Doc pos</th>--><th>PFSPO#</th><!--<th>SPO pos</th><th>Q</th><th>Unit</th>--><th>Pick-up Date</th><th>EXW</th><th>VIE Arrival</th><th>PFSPO Status</th><th>Transport Status</th><!--<th>planned Q</th>--></tr>
          <tr *ngFor="let spo of pfspoTable">
            <!-- <td>{{spo.parentPos+1}}</td> -->
            <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
              [queryParams]="{code: spo.document.code}" >{{spo.document | documentNumber}}</a></td>
            <!-- <td>{{spo.pos}}</td> -->
            <!-- <td>{{spo.docLineItem?.displayUnitQuantity}}</td>
            <td>{{unitData.get(spo.docLineItem?.displayUnit)?.short}}</td> -->
            <td>{{spo.document.readyForPickupDate | date : 'yy-MM-dd'}}</td>
            <td>{{spo.document.exwJapanDate | date : 'yy-MM-dd'}}</td>
            <td>{{spo.document.arrivingVieDate | date : 'yy-MM-dd'}}</td>
            <td>{{spoStatusData.get(spo.document.transportRun?.spoStatus)?.name}}</td>
            <td>{{transportStatusData.get(this.compilation.transportRun?.transportStatus)?.name}}</td>
            <!-- <td>{{spo.quantity}}</td> -->
          </tr>
        </table>

      </div>
    </ng-container>
    <ng-container *ngIf="data.visibleMap.vieDispatchDate || data.readOnlyMap.vieDispatchDate">
      &nbsp;&nbsp;&nbsp;OC Related
      <div class="report-date-section">
        <ul class="report-fields" *ngIf="compilation">
          <li *ngIf="data.visibleMap.ocTable && !print && ocTable && ocTable.length" class="d-inline-block"><button class="nrk-button ml-1" (click)="ocDateToggle=!ocDateToggle">▼</button></li>

          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('vieDispatchDate'), field: 'vieDispatchDate', label: docConfig.get('vieDispatchDate')['label'] + (tree?.linkedPfspos?.length && tree.linkedPfspos[0]?.directDelivery ? ' = EXW' : '') }"></ng-container>
          <ng-container *ngTemplateOutlet="textfield; context: { $implicit: docConfig.get('transferTime2'), field: 'transferTime2' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('etaCustomerDate'), field: 'etaCustomerDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('expectedNextInvoiceDate'), field: 'expectedNextInvoiceDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('customerRequestedDeliveryDate'), field: 'customerRequestedDeliveryDate' }"></ng-container>
          <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('customerAcceptedDeliveryDate'), field: 'customerAcceptedDeliveryDate' }"></ng-container>
          <li *ngIf="ocTable && ocTable.length" class="report-date">Related Documents: {{ocTable.length}}</li>
        </ul>

        <table *ngIf="data.visibleMap.ocTable && ocDateToggle && ocTable && ocTable.length" class="nrk-table w-100">
          <tr><th>Doc Pos</th><th>OC#</th><th>OC Pos</th><th>Q</th><th>Unit</th><th>Dispatch Date</th><th>ETA Customer</th><th>CRDD</th><th>CADD</th><th>Planned Q</th></tr>
          <tr *ngFor="let oc of ocTable">
            <td>{{oc.parentPos}}</td>
            <td><a [routerLink]="['/pages/erp/document/' + (this.compilation.issuer === 3 ? 'nrkg' : 'nrka')]"
              [queryParams]="{code: oc.doc.code}" >{{oc.doc | documentNumber}}</a></td>
            <td>{{oc.pos}}</td>
            <td>{{oc.doc.displayUnitQuantity}}</td>
            <td>{{unitData.get(oc.doc.displayUnit)?.short}}</td>
            <td>{{oc.doc.vieDispatchDate | date : 'yy-MM-dd'}}</td>
            <td>{{oc.doc.etaCustomerDate | date : 'yy-MM-dd'}}</td>
            <td>{{oc.doc.customerRequestedDeliveryDate | date : 'yy-MM-dd'}}</td>
            <td>{{oc.doc.customerAcceptedDeliveryDate | date : 'yy-MM-dd'}}</td>
            <td>{{oc.quantity}}</td>
          </tr>
        </table>
      </div>
    </ng-container>
  </div>
</ng-container>



<!-- <ng-container *ngIf="print">
  <div>
    <ul class="report-fields" *ngIf="compilation">
      <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('offerValidity'), field: 'offerValidity' }"></ng-container>
    </ul>
  </div> -->
 
  <div *ngIf="data.visibleMap.offerValidity || data.readOnlyMap.offerValidity">
    <!-- &nbsp;&nbsp;&nbsp;Offer related -->
    <ul class="report-fields nrk-border-box" *ngIf="compilation">
      <ng-container *ngIf="data.visibleMap.fromValidity">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('fromValidity'), field: 'fromValidity' }"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('offerValidity'), field: 'offerValidity', width: '130px' }"></ng-container>
      <ng-container *ngIf="data.visibleMap.latestDeliveryDate && (compilation.latestDeliveryDate || !print)">
        <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('latestDeliveryDate'), field: 'latestDeliveryDate', width: '130px' }"></ng-container>
      </ng-container>

      <ng-container *ngIf="data.visibleMap.priceValidFrom && (compilation.priceValidFrom || !print)">
        <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('priceValidFrom'), field: 'priceValidFrom' }"></ng-container> -->
        <ng-container *ngTemplateOutlet="dateWithRef; context: { $implicit: docConfig.get('priceValidFrom'), title: 'Price Valid From', field: 'priceValidFrom' }"></ng-container>
      </ng-container>
      <ng-container *ngIf="data.visibleMap.priceValidTo && (compilation.priceValidTo || !print)">
        <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('priceValidTo'), field: 'priceValidTo' }"></ng-container> -->
        <ng-container *ngTemplateOutlet="dateWithRef; context: { $implicit: docConfig.get('priceValidTo'), title: 'Price Valid To', field: 'priceValidTo' }"></ng-container>
      </ng-container>
      <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get('latestOrderDate'), field: 'latestOrderDate' }"></ng-container> -->

      <!-- <ngx-doc-form-texfield  [(value)]="compilation.offerDatesText"></ngx-doc-form-texfield> -->
      <li class="report-date" style="width:30rem" *ngIf="!print">
        <!-- <label>Text</label> -->
        <ngx-form-text [multiline]="1" [(value)]="compilation.offerDatesText" [disabled]="disabled"></ngx-form-text>
      </li>
      <li class="report-date" style="width:20rem" *ngIf="print">
        {{compilation.offerDatesText}}
      </li>

    </ul>
  </div>
<!-- </ng-container> -->

<ng-template #dateWithRef let-field="field" let-title="title">
  <li class="report-date" style="text-align: center;width:125px">
    <div>{{title}}</div>
    <button *ngIf="!disabled" class="nrk-button" [nbPopover]="dateRefSelection">Assign Date</button>
    <ng-template #dateRefSelection>
      <div class="p-4">
        <h5 class="mb-3 text-center">{{title}}</h5>
        <div class="mb-3">
          <!-- <ngx-doc-form-dropdown [(value)]="compilation[field + 'Ref']" [options]="paymentDateOptions" (valueChange)="compilation[field] = compilation[compilation[field + 'Ref']]"></ngx-doc-form-dropdown> -->
          <ngx-doc-form-dropdown [(value)]="compilation[field + 'Ref']" [options]="paymentDateOptions"></ngx-doc-form-dropdown>
        </div>
        <ng-container *ngIf="!compilation[field + 'Ref']">
          <ngx-doc-form-date class="fullwidth" [(value)]="$any(compilation)[field]"></ngx-doc-form-date>
        </ng-container>
        <!-- <div>{{(item.paymentDateRef ? compilation[item.paymentDateRef] : item.paymentDate) | date : 'yyyy-MM-dd' }}</div> -->
      </div>
    </ng-template>
    <!-- <ng-container *ngTemplateOutlet="datefield; context: { $implicit: docConfig.get(field), field: field }"></ng-container> -->
    <!-- <ngx-doc-form-date *ngIf="compilation[field + 'Ref']" class="fullwidth" [(value)]="compilation[compilation.nextInvoiceDateRef]" [disabled]="true"></ngx-doc-form-date>
    <ngx-doc-form-date *ngIf="!compilation[field + 'Ref']" class="fullwidth" [(value)]="$any(compilation)[field]" [disabled]="disabled"></ngx-doc-form-date> -->
    <div *ngIf="compilation[field + 'Ref']">{{data.getOptionName(paymentDateOptions, compilation[field + 'Ref'])}}</div>
    <ngx-doc-form-date *ngIf="!print" class="fullwidth" [(value)]="$any(compilation)[field]" [disabled]="disabled"></ngx-doc-form-date>
    <div *ngIf="print">{{$any(compilation)[field] | date : 'yyyy-MM-dd'}}</div>
  </li>
</ng-template>